import { BundleTypes } from "../constants";

export const ProductOptionChangeEventID = "productOptionChangeEvent" + window?.kefi_bundles?.product?.id;

export const BUNDLE_CONTAINER_PLACEHOLDER_IDS = {
    [BundleTypes.STANDARD]: "kefi-standard-container",
    [BundleTypes.BXGY]: "kefi-bxgy-container",
    [BundleTypes.MIX_MATCH]: "kefi-mnm-container",
    [BundleTypes.BUY_N]: "kefi-buy-n-container",
    [BundleTypes.MIX_MATCH_SECTIONAL]: "kefi-mnms-container",
    [BundleTypes.VOLUME_DISCOUNT]: "kefi-volume-container",
    [BundleTypes.FBT]: "kefi-fbt-container",
    [BundleTypes.PRODUCT_ADDONS]: "kefi-pdo-container",
    [BundleTypes.BUNDLE_BUILDER_CTA]: "kefi-builder-cta-container",
};

export const MIX_MATCH_MOBILE_MAX_WIDTH = 600;

export const CART_COUNT_SELECTORS = [
    {
        selector: "div#CartCount[data-cart-count-bubble] > span[data-cart-count]",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "div#CartCount[site-header__cart-count] > span#item_count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "#cart-icon-bubble div[class~='cart-count-bubble'] > span",
        content: {
            type: "innerHtml",
        },
        onNotFound: (e: any) => {
            const t = document.getElementById("cart-icon-bubble");
            if (
                !t ||
                "A" !== t.tagName ||
                t.closest("#header__minicart") ||
                t.closest(".wt-header__panel__item--cart") ||
                t.classList.contains("bls-minicart-action") ||
                t.querySelector("span.cart-count-bubble")
            )
                return;
            if (0 === e) return;
            if (!t.querySelector("div.cart-count-bubble")) {
                const o = document.createElement("div");
                (o.classList.add("cart-count-bubble"), t.appendChild(o), (o.innerHTML = `<span>${e}</span>`));
            }
        },
    },
    {
        selector: "#sticky-app-client div[data-cl='sticky-button'] > div:last-child",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span[data-cart-count]",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span.cart_count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span.counter.qty",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: ".current-cart-count > span.inner-count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "[class*='cart-item-count']",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "[class*='cart-link__count']",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: ".cart-icon--basket2 > div",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span.bigcounter",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span.header__cart-count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: 'a[href*="/cart"].gt_show-cart > span.gt_cart-count',
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: 'button#CartButton > span[x-text="$store.cart_count.count"]',
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "#CartLink #CartCount",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: ".cart-count-bubble > span[data-cart-count]",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "div.header__cart-count > span[data-js-cart-count]",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: 'a[href*="/cart"] div[data-cart-count]',
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span.cart-items-count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: 'a[href*="/cart"][aria-label="Cart"].cart-icon--basket1 > div',
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "cart-count.header__cart-count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: ".Header__CartCount",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: 'a[href*="/cart"] #CartCount',
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: 'a[href*="/cart"] .js-cart-count',
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: 'a[href*="/cart"] span.site-header-cart--count',
        content: {
            type: "dataAttribute",
            attributeName: "data-header-cart-count",
        },
        onCountZero(e: any) {
            e.classList.remove("visible");
        },
        onCountNonZero(e: any) {
            e.classList.add("visible");
        },
    },
    {
        selector: 'a[href*="/cart"] span.header-cart__count',
        content: {
            type: "innerHtml",
        },
        onCountZero(e: any) {
            const t = e.closest(".has-cart-count");
            null == t || t.classList.remove("has-cart-count");
        },
        onCountNonZero(e: any) {
            const t = e.closest(".header-cart[data-ajax-cart-trigger]");
            null == t || t.classList.add("has-cart-count");
        },
    },
    {
        selector: 'a[href*="/cart"] .cart-link__bubble',
        content: {
            type: "noContent",
        },
        onCountZero(e: any) {
            e.classList.remove("cart-link__bubble--visible");
        },
        onCountNonZero(e: any) {
            e.classList.add("cart-link__bubble--visible");
        },
    },
    {
        selector: ".cart-link__bubble-num",
        content: {
            type: "innerHtml",
        },
        onCountZero() {
            var e;
            "modernbandit.myshopify.com" === (null == (e = window.kefi_bundles) ? void 0 : e.shop) &&
                document.body.classList.remove("cart-has-items");
        },
        onCountNonZero() {
            var e;
            "modernbandit.myshopify.com" === (null == (e = window.kefi_bundles) ? void 0 : e.shop) &&
                document.body.classList.add("cart-has-items");
        },
    },
    {
        selector: 'a[href*="/cart"].header-trigger__link--cart',
        content: {
            type: "noContent",
        },
        onCountZero(e: any) {
            e.classList.remove("js-cart-full");
        },
        onCountNonZero(e: any) {
            e.classList.add("js-cart-full");
        },
    },
    {
        selector: 'a[href*="/cart"] .sf-cart-count',
        content: {
            type: "innerHtml",
        },
        onCountZero(e: any) {
            let t;
            null === (t = e.closest("section.sf-header")) || void 0 === t || t.classList.remove("cart-has-items");
        },
        onCountNonZero(e: any) {
            let t;
            null === (t = e.closest("section.sf-header")) || void 0 === t || t.classList.add("cart-has-items");
        },
    },
    {
        selector: "#header-cart-drawer-item-count",
        content: {
            type: "innerHtml",
        },
        onCountZero(e: any) {
            e.classList.add("hide");
        },
        onCountNonZero(e: any) {
            e.classList.remove("hide");
        },
    },
    {
        selector: ".cart-count-badge",
        content: {
            type: "innerHtml",
        },
        onCountZero(e: any) {
            e.classList.add("hide");
        },
        onCountNonZero(e: any) {
            e.classList.remove("hide");
        },
    },
    {
        selector: 'a[href*="/cart"] #cart-item-count',
        content: {
            type: "innerHtml",
        },
        onCountZero(e: any) {
            e.classList.remove("visible");
        },
        onCountNonZero(e: any) {
            e.classList.add("visible");
        },
    },
    {
        selector: "a span[data-header-cart-count]",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "a[href*='/cart'] span.header__cart-count-number",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: 'a[href*="/cart"] .m-cart-count-bubble.m-cart-count',
        selectAll: !0,
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "div#cart-icon-bubble div.header__cart-count > span",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span.cart-item-count-bubble.cart-item-count-header.cart-item-count-header--quantity",
        selectAll: !0,
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: ".header-cart-icon > .js-cart-count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "a[data-drawer-view='cart-drawer'][data-cart-count]",
        content: {
            type: "dataAttribute",
            attributeName: "data-cart-count",
        },
        selectAll: !0,
    },
    {
        selector: "cart-count.count-bubble",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "cart-count#CartCount div.cart-count > span",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span.cart-bubble__text-count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "div[header-cart-bubble] > span.header__cart__icon-count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: ".site-header__cart-count > span",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "#cart-icon-bubble > .wt-header__panel__counter",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span[data-instant-dynamic-content-source='CART_COUNT']",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "a#cart-icon-bubble.bls-minicart-action .cart-count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "span.cart_item_count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "a[href*='/cart'] span[x-text='$store.cart_count.count']",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "a[href*='/cart'] span.thb-item-count",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "cart-count:not(#CartCount)",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "a[href*='/cart'] span.cart-count-bubble span:not(.visually-hidden)",
        content: {
            type: "innerHtml",
        },
    },
    {
        selector: "button[onclick='cartDrawer.open();'] span.cart-badge",
        content: {
            type: "innerHtml",
        },
    },
];
